/**
 * List of paths that don't require authentication
 * and should not be used as redirect targets after login
 */
export const ANONYMOUS_PATHS = [
    '/login',
    '/register',
    '/forgot-password',
    '/reset-password',
    '/self-register',
    '/accept-invite',
    '/verify-email',
];

/**
 * Check if a given path is an anonymous path
 */
export const isAnonymousPath = (path: string): boolean => {
    return ANONYMOUS_PATHS.some(anonymousPath => path.includes(anonymousPath));
};
